/* eslint-disable */
export default {
    questionnaire_research_questions_intro: "Bevor Sie Ihr Programm starten, füllen Sie bitte die nachfolgenden Felder aus.\n\nANMERKUNG: Die von Ihnen im Folgenden gemachten Angaben werden ausschließlich zu Forschungszwecken verwendet.",
    questionnaire_research_questions_title: "Willkommen",
    questionnaire_research_questions_save: "Speichern",
    questionnaire_page_title: "Fragebogen",
    questionnaire_go_back: "Zurück",
    questionnaire_submit_questionnaire: "Speichern und zur Übersicht",
    questionnaire_next: "Weiter",
    questionnaire_back: "Zurück",
    questionnaire_nl_NL: "Niederländisch",
    questionnaire_en_GB: "English",
    questionnaire_finish: "Abrunden",
    questionnaire_start: "Start",
    questionnaire_practice_question: "Übungsfrage",
    questionnaire_example_question: "Beispielfrage",
    questionnaire_preparation_practice_questions_show_answer: "Antwort anzeigen",
    questionnaire_continue: "Weiter",
    questionnaire_question: "Frage",
    questionnaire_question_required_notification: "ACHTUNG: Die Frage wurde nicht beantwortet. Sie können nur zur nächsten Seite gehen, wenn Sie die Frage beantwortet haben.",
    questionnaire_instruction: "Anweisung",
    questionnaire_route_to_overview: "Zur Übersicht",
    questionnaire_could_not_retrieve_questionnaires: "Konnte keine Fragebogen abrufen. Versuchen Sie es später nochmals.",
    questionnaire_could_not_retrieve_psession: "Konnte keine Angaben abrufen. Versuchen Sie es später nochmals.",
    questionnaire_finish_screen_body: "<p>Alle Fragen wurden beantwortet, wir danken Ihnen für Ihre Teilnahme!</p><p>Wenn Sie etwas ändern möchten, können Sie zum Fragebogen zurückkehren. In allen anderen Fällen klicken Sie bitte auf die Schaltfläche unten, um Ihre Antworten zu übermitteln.</p><p><br></p><p><br></p>",
    questionnaire_of: "von",
    questionnaire_correct: "Korrekt",
    questionnaire_incorrect: "Inkorrekt",
    questionnaire_maximum_answers_given: "Die maximale Zahlan Antworten wurde bereits gegeben",
    questionnaire_dilemma_test_response_intro: "Geben Sie nun an, wie wichtig diese Überlegungen für die von Ihnen getroffenen Entscheidungen waren. <br />Auf dem nächsten Bildschirm werden die Überlegungen dargestellt.",
    questionnaire_de_DE: "Deutsch",
    questionnaire_fr_FR: "Französisch",
    questionnaire_no_questionnaires_available: "There are currently no questionnaires available yet. These will be made available at a later stage.",
    questionnaire_update_answer_error: "Something went wrong while saving the answer, please try again later.",
    questionnaire_complete_questionnaire_error: "Something went wrong while completing the questionnaire, please try again later.",
    questionnaire_fetch_questionnaire_error: "Something went wrong while fetching the questionnaire, please try again later.",
    questionnaire_back_to_overview_cancelled: "This questionnaire has been cancelled.",
    questionnaire_back_to_overview_invalidated: "This questionnaire has been invalidated.",
    questionnaire_back_to_overview_finished: "This questionnaire has been completed.",
    questionnaire_return_to_overview_button: "Click here to return to the overview",
    questionnaire_back_to_overview_deadline_exceeded: "The deadline of this questionnaire has exceeded.",
    questionnaire_fetch_questionnaire_intro_error: "Something went wrong while fetching the introduction of the questionnaire, please try again later.",
    questionnaire_finish_screen_finish_button: "Finish",
    questionnaire_return_to_practice_site_button: "Return to the practice site",
    questionnaire_practice_feedback_text_a: "Ihre Punktzahl für den Übungstest:",
    questionnaire_practice_feedback_text_b: "von",
    questionnaire_practice_verify_answers_error: "Something went wrong while verifying the answers, please try again later.",
    questionnaire_dilemma_test_see_case: "See case",
    questionnaire_answer_options: "Antwortmöglichkeiten",
    questionnaire_start_questionnaire_error: "Something went wrong while starting the questionnaire, please try again later.",
    questionnaire_dilemma_test_response_intro_case_dialog: "Geben Sie nun an, wie wichtig diese Überlegungen für die von Ihnen getroffenen Entscheidungen waren.",
    questionnaire_time_left: "Übrige Zeit",
    questionnaire_minutes_label: "Minuten",
    questionnaire_practice_feedback_question: "Frage",
    questionnaire_practice_feedback_correct: "Richtig",
    questionnaire_practice_feedback_wrong: "Falsch",
    questionnaire_finish_screen_practice_explanation_flow: "Sie haben alle Fragen überprüft, klicken Sie auf \"Fertig\", um zur Übungsseite zurückzukehren.",
    "questionnaire_show explanations_button": "Erklärungen anzeigen",
    questionnaire_not_answered_explanation_flow: "Diese Frage wurde nicht beantwortet",
    questionnaire_show_explanations_button: "Erläuterungen anzeigen"
};
